module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Add Actual Amount for @" + _vm._s(_vm.report.instagram))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "mt-3 body-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Amount",
      "type": "number",
      "hide-details": "",
      "prefix": "S$",
      "error-messages": _vm.amountErrors
    },
    on: {
      "input": function($event) {
        return _vm.$v.amount.$touch()
      },
      "blur": function($event) {
        return _vm.$v.amount.$touch()
      }
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = _vm._n($$v)
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "id": "close",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": "",
      "disabled": _vm.$v.amount.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b54347f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/ActualAmountModal.vue
// module id = 1996
// module chunks = 0